<template>
  <nav
    @mouseleave="onNavLeave"
    class="main-navigation"
    ref="mainNav"
    aria-label="Main Navigation"
  >
    <ul
      @mouseover="hoveredTrigger"
      @mouseleave="onUlLeave"
      :class="{ 'hover' : hovered, 'clicked' : clicked }"
    >
      <li
        aria-haspopup="true"
        :key="category.slug"
        v-for="category in visibleCategories"
        :class="{ 'offer' : [ 1163, 25831 ].includes(category.id) }"
      >
        <main-nav-inner
          :category="category"
        />
      </li>
    </ul>
  </nav>
</template>

<script>
import SidebarMenu from '@vue-storefront/core/compatibility/components/blocks/SidebarMenu/SidebarMenu'
import EventBus from '@vue-storefront/core/compatibility/plugins/event-bus'
import MainNavInner from 'theme/components/core/blocks/Custom/MainNavInner'
import { loadMenuCategories } from 'theme/helpers/menu'

export default {
  data () {
    return {
      hovered: false,
      clicked: false
    }
  },
  components: {
    MainNavInner
  },
  mixins: [SidebarMenu],
  computed: {
    visibleCategories () {
      return this.categories.filter(category => {
        return category.level === 2 && category.include_in_menu === 1
      }).sort((a, b) => a.position - b.position)
    }
  },
  created () {
    this.onMegamenuClicked = () => {
      this.clicked = true
      clearTimeout(this._clickedTimer)
      this._clickedTimer = setTimeout(() => { this.clicked = false }, 2000)
    }
    EventBus.$on('megamenu-clicked', this.onMegamenuClicked)
  },
  mounted () {
    const menu = this.$store.state['category-next'].menuCategories
    if (!menu || !menu.length) {
      loadMenuCategories()
    }
    document.documentElement.addEventListener('mouseleave', this.onDocumentMouseLeave)
  },
  beforeDestroy () {
    EventBus.$off('megamenu-clicked', this.onMegamenuClicked)
    document.documentElement.removeEventListener('mouseleave', this.onDocumentMouseLeave)
    clearTimeout(this._clickedTimer)
    clearTimeout(this._hoverTriggerTimer)
    clearTimeout(this._hoverRemoveTimer)
  },
  /* async mounted () {
    if (this.$refs.mainNav.scrollHeight === 0) {
      return;
    }
    this.$nextTick(async () => {
      loadMenuCategories()
    });
  }, */
  methods: {
    // Timeout value must be equal to transition-delay + transition-duration for the main nav dropdowns (see _header.scss)
    hoveredTrigger () {
      if (this._hoverRemoveTimer) {
        clearTimeout(this._hoverRemoveTimer)
        this._hoverRemoveTimer = null
      }
      if (this.hovered || this._hoverTriggerTimer) return
      this._hoverTriggerTimer = setTimeout(() => {
        this.hovered = true
        this._hoverTriggerTimer = null
      }, 1000)
    },
    hoveredRemove () {
      if (this._hoverTriggerTimer) {
        clearTimeout(this._hoverTriggerTimer)
        this._hoverTriggerTimer = null
      }
      if (this._hoverRemoveTimer) {
        clearTimeout(this._hoverRemoveTimer)
      }
      this._hoverRemoveTimer = setTimeout(() => {
        this.hovered = false
        this._hoverRemoveTimer = null
      }, 1000)
    },
    onUlLeave () {
      this.hovered = false
      if (this._hoverTriggerTimer) {
        clearTimeout(this._hoverTriggerTimer)
        this._hoverTriggerTimer = null
      }
    },
    onNavLeave () {
      EventBus.$emit('megamenu-close-all')
      this.hoveredRemove()
    },
    onDocumentMouseLeave () {
      EventBus.$emit('megamenu-close-all')
      this.hovered = false
      if (this._hoverTriggerTimer) {
        clearTimeout(this._hoverTriggerTimer)
        this._hoverTriggerTimer = null
      }
      if (this._hoverRemoveTimer) {
        clearTimeout(this._hoverRemoveTimer)
        this._hoverRemoveTimer = null
      }
    }
    /* addBodyClass: function() {
      myBody.classList.add('noscroll');
    },
    removeBodyClass: function() {
      myBody.classList.remove('noscroll');
    } */
  }
}
</script>
